import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useLaunchUrl } from '../../../../../../contexts/LaunchContext';
import { sendAnalyticsEvent } from '../../../../../../../actions/reports';
import { viewStudentDetails } from '../../../../../../../analyticsEvents';
import EmailTooltip from '../../../../../../../components/EmailTooltip/EmailTooltip';
import s from './StudentColumn.module.css';

function StudentColumn({
  row,
  launchProps,
  sendAnalyticsEvent: analyticsEvent,
}) {
  const { student } = row;
  const getLaunchUrl = useLaunchUrl();
  const {
    courseId,
    courseShortId,
    productModelId,
    assignmentId,
    activityId,
    tool,
  } = launchProps || {};

  const launchData = {
    course_id: courseId,
    actual_course_id: courseId,
    short_id: courseShortId,
    productModelId,
    id: assignmentId,
    activityId,
    tool,
  };
  const activityLink = getLaunchUrl(launchData);
  const separator = activityLink && activityLink.includes('?') ? '&' : '?';
  const studentAssignmentLink = `${activityLink}${separator}studentUserId=${encodeURIComponent(
    student.studentId ?? ''
  )}`;

  const handleStudentClick = () => {
    analyticsEvent(
      viewStudentDetails({
        location: 'GRS Insights Student Responses',
        assignment_id: assignmentId,
      })
    );
  };

  const studentName = (
    <div className={s.studentName}>
      {student.firstName} <span>{student.lastName}</span>
    </div>
  );

  return (
    <div className={s.studentCell}>
      {activityLink ? (
        <a
          className={s.studentNameLink}
          target="_blank"
          rel="noopener noreferrer"
          href={studentAssignmentLink}
          data-test-id="GRS_StudentName_openIAC"
          onClick={handleStudentClick}
        >
          {studentName}
        </a>
      ) : (
        studentName
      )}

      <EmailTooltip email={student.email}>
        <div
          className={s.studentEmail}
          data-test-id={`${student.email}-student-email`}
        >
          {student.email}
        </div>
      </EmailTooltip>
    </div>
  );
}

StudentColumn.propTypes = {
  row: PropTypes.shape({
    student: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      studentId: PropTypes.string,
    }),
  }).isRequired,
  launchProps: PropTypes.shape({
    courseId: PropTypes.string,
    courseShortId: PropTypes.string,
    productModelId: PropTypes.number,
    assignmentId: PropTypes.string,
    activityId: PropTypes.string,
    tool: PropTypes.string,
  }),
  sendAnalyticsEvent: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      sendAnalyticsEvent,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(StudentColumn);
